import { getActivePinia } from 'pinia';
import { useProductFinderAnalyticsStore } from '~/stores/productFinderAnalyticsStore/productFinderAnalyticsStore';
import type { ProductFinderAttribution } from '~/utils/productFinderAnalytics/types';

export function getProductFinderAttributionForSku(
  sku: string
): ProductFinderAttribution | undefined {
  if (!getActivePinia()) {
    return undefined;
  }

  return useProductFinderAnalyticsStore().getAttribution(sku);
}

export function hasProductFinderAttributionForSkus(skus: string[]): boolean {
  if (!getActivePinia()) {
    return false;
  }

  return useProductFinderAnalyticsStore().hasFinderAttributionInCart(skus);
}
